module.exports = __webpack_public_path__ + "img/com (4).5c095b4d.png";